var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgApps = function SvgApps(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    clipPath: "url(#apps_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.648 13.588a4.941 4.941 0 1 0 0-9.882 4.941 4.941 0 0 0 0 9.882Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.293 1.647V.412H.41v9.882h1.318"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "apps_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h14v14H0z"
  })))));
};
export default SvgApps;